import { FC } from "react";
import { Button as AntButton, Modal } from 'antd';
import styled from 'styled-components';
import { useTranslation } from "react-i18next";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  submitBusStatus: () => void;
  rideGbn: string|undefined;
  isStart: boolean;
}

const Block = styled.div`
  text-align: center;
`;

const ConfirmStatusModal: FC<IProps> = ({
  visible,
  setVisible,
  rideGbn,
  isStart,
  submitBusStatus,
}) => {
  const { t } = useTranslation();

  const getRideLabel1 = () => {
    switch (rideGbn) {
      case 'UP':
        return t('shuttle.text.8');
      case 'DN':
        return t('shuttle.text.9');
      default:
        return '';
    }
  }

  const getRideLabel2 = () => {
    switch (rideGbn) {
      case 'UP':
        return t('shuttle.text.10');
      case 'DN':
        return t('shuttle.text.11');
      default:
        return '';
    }
  }

  const getText = () => {
    if (isStart) {
      return (
        <>
          {t('shuttle.text.12')} {getRideLabel1()} {t('shuttle.text.13')}<br />
          ({t('shuttle.text.14')} {getRideLabel1()} {t('shuttle.text.15')}<br />
          {getRideLabel2()} {t('shuttle.text.16')})
        </>
      );
    } else {
      return (
        <>
          {t('shuttle.text.12')} {getRideLabel1()} {t('shuttle.text.17')}<br />
          ({t('shuttle.text.14')} {getRideLabel1()} {t('shuttle.text.15')}<br />
          {getRideLabel2()} {t('shuttle.text.18')})
        </>
      );
    }
  }

  return (
    <Modal
      title={t('shuttle.text.19')}
      visible={visible}
      onCancel={() => setVisible(false)}
      width={320}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton
            key="submit"
            className='btn-basic pink'
            onClick={submitBusStatus}
          >
            {t('common.button.confirm')}
          </AntButton>
          <AntButton
            key="cancel"
            className='btn-basic gray'
            onClick={() => setVisible(false)}
          >
            {t('common.button.cancel')}
          </AntButton>
        </div>
      ]}
    >
      <Block>
        {getText()}
      </Block>
    </Modal>
  );
}

export default ConfirmStatusModal;
